'use client';
import { FC } from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { format } from 'date-fns';
import { STATUS_MAP } from '@/lib/types/statusTypes';
import { useUserResolution } from '@/lib/options/useUserResolution';

interface ReadOnlyFooterProps {
  lastChangedDate?: Date;
  lastChangedBy: string;
  status: string;
}

export const ReadOnlyFooter: FC<ReadOnlyFooterProps> = ({ lastChangedDate, lastChangedBy, status }) => {
  const { resolveUser } = useUserResolution();
  const formatStatus = (status: string | undefined) => {
    if (!status) return 'Not specified';

    const statusInfo = STATUS_MAP[status];
    const label = statusInfo?.label || status;

    let chipColor: 'default' | 'success' | 'warning' = 'default';
    if (label === 'Submitted') chipColor = 'success';
    else if (label === 'Pending') chipColor = 'warning';

    return <Chip label={label} color={chipColor} size="small" icon={statusInfo?.icon} sx={{ ml: 1 }} />;
  };

  const formattedDate = lastChangedDate ? format(new Date(lastChangedDate), 'PPpp') : 'Unknown';
  return (
    <Box
      sx={{
        borderTop: '1px solid #e0e0e0',
        mt: 3,
        pt: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        fontSize: '0.875rem',
        color: 'text.secondary',
      }}
    >
      <Typography variant="body1" component="div" sx={{ fontSize: '1rem', flex: 1, mr: 2 }}>
        Last modification on <strong>{formattedDate}</strong> by{' '}
        <strong>{lastChangedBy ? resolveUser(lastChangedBy) : 'Unknown'}</strong>.&nbsp; Current status:{' '}
        {formatStatus(status)}
      </Typography>
    </Box>
  );
};

export default ReadOnlyFooter;
